import React, {useEffect} from "react";
import {connect} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

// components
import WishlistSalesforceForm from "./_form";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import WishlistSalesforceFilters from "./_filters";

// labels
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {
    LB_ACTIONS, LB_DESTINY,
    LB_ORIGIN, LB_SALESFORCE_ID,
    LB_SERVICE, LIST, NO_DATA_FOUND
} from "../../../components/i18n/i18n";

// actions
import {genericActions} from "../../../redux/actions/generics/GenericActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {setMapConfig, setViewMode} from "../../../redux/actions/generalActions/mainActions";

// services
import {wishlistSalesforceService} from "../../../jwt/_services/salesforce/wishlistSalesforceService";


const WishlistSalesforceList = (props) => {
    const { app } = props.mainProps;
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps

    const fbDataBase = {id: app?.fbDataBase?.id}

    useEffect( () => {
        if(filter)
            return

        props.setFilter({
            fbDataBase,
            item: { name: null }
        })
    }, []);


    useEffect(() => {
        if(!filter)
            return

        genericActions.search(wishlistSalesforceService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);


    const editItem = (data) => {
        props.setForm(true, false, false);
        props.setItem(data);
        ModalFormContainer(WishlistSalesforceForm, {data, Form:WishlistSalesforceForm})
    }


    const confirmDelete = (data) => ConfirmDelete({
        remove : genericActions.remove ,
        fbDataBaseId: app?.fbDataBase?.id,
        data : data,
        service: wishlistSalesforceService,
    } );


    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };


    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, {
            dataField: 'servicio',
            text: `${LB_SERVICE}`,
        }, {
            dataField: 'origen',
            text: `${LB_ORIGIN}`,
            formatter: (cell, row) => <>{row?.origen?.name}</>
        }, {
            dataField: 'destino',
            text: `${LB_DESTINY}`,
            formatter: (cell, row) => <>{row?.destino?.name}</>
        }, {
            dataField: 'idSalesforce',
            text: `${LB_SALESFORCE_ID}`,
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '140px'},
            formatter: (cell, row) => <>
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
            </>
        }];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2" />{LIST}
        </CardTitle>


        <CardBody className="">
            <WishlistSalesforceFilters />

            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setForm,
    setItem,
    setFilter,
    setViewMode,
    setMapConfig,
    setTableParams,
})
export default connect(mapStateToProps, mapActionsToProps)(WishlistSalesforceList);